import { faImage } from '@fortawesome/pro-regular-svg-icons/faImage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './AddPhoto.module.scss';

interface AddPhotoProps {
    className?: string;
    onClick?: () => void;
}

export const AddPhoto: FunctionComponent<AddPhotoProps> = props => {
    return (
        <div
            className={clsx(styles.container, props.className)}
            onClick={props.onClick}
        >
            <FontAwesomeIcon
                icon={faImage}
                color="#D3D3D3"
                className={styles.icon}
            />
            <span className={styles.text}>+ Add Photo</span>
        </div>
    );
};

export default AddPhoto;
